<script setup>
// El icono de Apple TestFlight, para la casilla de la beta en el alta.
//
// ⚠️ **Vive aquí y no en `AstraIcon` a propósito**, igual que `AppleIcon` y
// `GooglePlayIcon`: son logotipos de marca **a color**, no iconos del sistema.
// `AstraIcon` pinta con `currentColor` y este tiene colores propios.
//
// ⚠️ **Está dibujado, no es el vector de Apple.** No hay SVG oficial en el
// repositorio: es el cuadrado con su degradado, el filete y la hélice de tres
// aspas a 120°, sobre un lienzo de 512. Reproduce la estructura y se reconoce
// a 16 px, pero **no es exacto** — le faltan la retícula de alambre de dos
// aspas y el «DESIGNED BY APPLE IN CALIFORNIA» del original, que a este tamaño
// no se ven. Si algún día hace falta fidelidad de marca, se sustituye por el
// vector oficial y esto se borra.
//
// Ver `AppleIcon`: un id por instancia, o el segundo icono de la página se
// queda sin degradado en cuanto el primero se desmonta.
import { useId } from "vue";

defineProps({
  size: { type: [Number, String], default: 16 },
});

const id = `testflight-grad-${useId()}`;
</script>

<template>
  <svg
    class="testflight-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    :width="size"
    :height="size"
    aria-hidden="true"
    focusable="false"
  >
    <defs>
      <linearGradient :id="id" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#35A3F4" />
        <stop offset="1" stop-color="#1667E8" />
      </linearGradient>
    </defs>
    <rect x="16" y="16" width="480" height="480" rx="112" :fill="`url(#${id})`" />
    <rect
      x="56"
      y="56"
      width="400"
      height="400"
      rx="82"
      fill="none"
      stroke="#fff"
      stroke-width="13"
    />
    <circle
      cx="256"
      cy="256"
      r="150"
      fill="none"
      stroke="#fff"
      stroke-opacity=".22"
      stroke-width="12"
    />
    <path d="M256.0 248.0A39.0 104.0 0 0 1 256.0 40.0A39.0 104.0 0 0 1 256.0 248.0Z" fill="#fff" />
    <path d="M262.9 260.0A39.0 104.0 120 0 1 443.1 364.0A39.0 104.0 120 0 1 262.9 260.0Z" fill="#fff" />
    <path d="M249.1 260.0A39.0 104.0 240 0 1 68.9 364.0A39.0 104.0 240 0 1 249.1 260.0Z" fill="#fff" />
  </svg>
</template>

<style scoped lang="scss">
.testflight-icon {
  display: inline-block;
  flex: none;
  // Ver AstraIcon: la capa legacy estira todo `svg` al 100% y un selector de
  // etiqueta gana al atributo.
  width: auto;
  height: auto;
}
</style>
